import React from "react";
import { RightPanel } from "../../../../../../../components/RightPanel";
import { AutomobileVehicleInformation } from "./AutomobileVehicleInformation";
import { IAutomobileVehicleInformation } from "../../../../../../../redux/automobileVehicle/automobileVehicle.types";
import { clearAutomobileVehicleState } from "../../../../../../../redux/automobileVehicle/automobileVehicleActions";
import { useDispatchWrapper } from "../../../../../../../hooks";

interface IAutomobileVehicleInfoRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  vehicleNumber?: number;
  onSaveSuccess: (driver: IAutomobileVehicleInformation) => void;
  readonly?: boolean;
  onClose: () => void;
  staticStatusValue?: string;
  created_from?: string;
  initialData?: IAutomobileVehicleInformation;
  disableApiCalls?: boolean;
}

export const AutomobileVehicleInfoRightPanel: React.FC<
  IAutomobileVehicleInfoRightPanelProps
> = (props) => {
  const {
    customerId,
    customerPolicyId,
    vehicleNumber,
    onClose,
    onSaveSuccess,
    readonly,
    staticStatusValue,
    created_from,
    initialData,
    disableApiCalls,
  } = props;

  const dispatch = useDispatchWrapper();

  React.useEffect(()=>{
     return () => {
          dispatch(clearAutomobileVehicleState());
        };
  },[])

  return (
    <>
      <RightPanel
        heading="Vehicle Information"
        //subHeading="Add notes or comments"
        open={true}
        onClose={onClose}
        width="90%"
      >
        <AutomobileVehicleInformation
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          vehicleNumber={vehicleNumber}
          onSaveSuccess={onSaveSuccess}
          readOnly={readonly}
          fromRightPanel
          showOnlySaveButton
          staticStatusValue={staticStatusValue}
          created_from={created_from}
          initialData={initialData}
          disableApiCalls={disableApiCalls}
        />
      </RightPanel>
    </>
  );
};
